export const ApiUrl = {
  // BASEURL: "http://localhost:8200/api",
  BASEURL: "https://pm.vijayhomeservice.in/api",

  // IMAGEURL: "https://pm.vijayhomeservice.in/",

  IMAGEURL: "http://localhost:8200/",
  ADDCATEGORY: "/cate/addcategory",
  GETCATEGORY: "/cate/getcategory",
  DELETECATEGORY: "/cate/trashcate/",
  UPDATECATEGORY: "/cate/update/",

  ADDSUBCATE: "/subcate/addsubcate",
  GETSUBCATE: "/subcate/getsubcate",
  DELETESUBCATE: "/subcate/trash/",
  UPDATESUBCATE: "/subcate/update/",

  ADDSERVICE: "/service/addservice",
  GETSERVICE: "/service/getservice",
  DELETESERVICE: "/service/trash/",
  UPDATESERVICE: "/service/update/",
  UPDATESERVICESLOTS: "/service/updateslot/",

  ADDSLOTS: "/slot/addslots",
  GETSLOTS: "/slot/getslots",
  DELETESLOTS: "/slot/trash/",
  UPDATESLOTS: "/slot/update/",

  ADDITEMS: "/item/additem",
  GETITEMS: "/item/getitem",
  DELETEITEMS: "/item/trash/",
  UPDATEITEMS: "/item/update/",

  ADDORDER: "/order/addorder",
  UPDATORDER: "/order/update/",
  UPDATVENDOR: "/order/updatevendor/",
  GETORDER: "/order/getorder",

  ADDENQUIRY: "/enquiry/addenquiry",
  UPDATENQUIRY: "/enquiry/update/",
  GETENQUIRY: "/enquiry/getenquiry",
  DELETEENQUIRY: "/enquiry/trash/",
  GETENQUIRYTODAY: "/enquiry/findbyTodayEnquiry",
  GETENQUIRYNEW: "/enquiry/FindNewEnquiry",

  ADDFALLOWUP: "/fallowup/addfallowup",
  UPDATFALLOWUP: "/fallowup/update/",
  GETFALLOWUP: "/fallowup/getfallowup",
  DELETEFALLOWUP: "/fallowup/trash/",

  ADDQUOTE: "/quote/addquote",
  UPDATQUOTE: "/quote/update/",
  GETQUOTE: "/quote/getquote",
  GetByDateQuote: "/quote/getQuotebyCreationDate/",
  DELETEQUOTE: "/quote/trash/",
  GETCONFIFRM: "/quote/getCovertedQuotes",
  GETCALendarDte: "/quote/getReturnsDates",

  ADDQUOTEITEM: "/qtitem/addqtitem",
  UPDATQUOTEITEM: "/qtitem/update/",
  GETQUOTEITEM: "/qtitem/getqtitem",
  DELETEQUOTEITEM: "/qtitem/trash/",

  ADDBANNER: "/banner/addbanner",
  UPDATBANNER: "/banner/update/",
  GETBANNER: "/banner/getbanner",
  DELETEBANNER: "/banner/trash/",

  CREATEADDONS: "/AddOns/CreateAddOns",
  UPDATEADDONS: "/AddOns/update/",
  GETADDONS: "/AddOns/getAddOns",
  DELETEADDONS: "/AddOns/trash/",

  ADDVIDEOBANNER: "/video/AddPMBannerVideo",
  UPDATVIDEOBANNER: "/video/updatePMBannerVideo/",
  GETVIDEOBANNER: "/video/getPMBannerVideo",
  DELETEVIDEOBANNER: "/video/trash/",

  UPDATVENDOR: "/update/",
  GETVENDOR: "/getalltechnician",
  DELETEVENDOR: "/deletetechnician/",

  ADDVOUCHER: "/voucher/addvoucher",
  UPDATVOUCHER: "/voucher/editvoucher/",
  GETVOUCHER: "/voucher/getvoucher",
  DELETEVOUCHER: "/voucher/deletevoucher/",

  ADDVEHICAL: "/addvehical",
  UPDATVEHICAL: "/updatevehical/",
  GETVEHICAL: "/getvehical",
  DELETEVEHICAL: "/trashvehical/",
};
